module.exports = __webpack_public_path__ + "static/media/book-cover-bee.3b75f19d.jpg";